import { Map } from 'immutable';

import { OPERATIONS, OVERSET, VALUE } from '../../constants/product';
import { ATTRIBUTE } from '../../constants/attributes';
import { SHOPIFY } from '../../constants/channels';
import { FORM } from '../../constants/forms';

export function editSearchEngineListing({ product: source, ...values }) {
  let product = source;
  const channel = product.get('channel');
  const operations = [];

  switch (channel) {
    case SHOPIFY: {
      if (values[ATTRIBUTE.META_DESCRIPTION] !== undefined) {
        const { [OVERSET]: overset, [VALUE]: value } = values[ATTRIBUTE.META_DESCRIPTION];

        product = product.setIn([FORM.SEO, ATTRIBUTE.META_DESCRIPTION, VALUE], value);

        if (overset) {
          product = product.setIn([FORM.SEO, ATTRIBUTE.META_DESCRIPTION, OVERSET], true);
        } else if (value && product.getIn([FORM.SEO, ATTRIBUTE.META_DESCRIPTION, OVERSET])) {
          product = product.deleteIn([FORM.SEO, ATTRIBUTE.META_DESCRIPTION, OVERSET]);
        }

        if (value) {
          operations.push(Map({ type: OPERATIONS[SHOPIFY].META_DESCRIPTION, value }));
        }
      }

      if (values[ATTRIBUTE.PAGE_TITLE] !== undefined) {
        const { [OVERSET]: overset, [VALUE]: value } = values[ATTRIBUTE.PAGE_TITLE];

        product = product.setIn([FORM.SEO, ATTRIBUTE.PAGE_TITLE, VALUE], value);

        if (overset) {
          product = product.setIn([FORM.SEO, ATTRIBUTE.PAGE_TITLE, OVERSET], true);
        } else if (value && product.getIn([FORM.SEO, ATTRIBUTE.PAGE_TITLE, OVERSET])) {
          product = product.deleteIn([FORM.SEO, ATTRIBUTE.PAGE_TITLE, OVERSET]);
        }

        if (value) {
          operations.push(Map({ type: OPERATIONS[SHOPIFY].PAGE_TITLE, value }));
        }
      }

      break;
    }

    default: {
      break;
    }
  }

  return { operations, product };
}
